import styled from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.backgrounds.modal};
  border-radius: 2px;
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.03);
  pointer-events: auto;
`;
Wrapper.displayName = 'Wrapper';

export const Text = styled.p`
  font-size: 13.5px;
  color: ${colors.greyBlue};
  text-align: center;
`;
Text.displayName = 'Text';

export const Link = styled.a`
  font-size: 13.5px;
  color: ${colors.blueCerulean};
  cursor: pointer;
  text-decoration: none;
`;
Text.displayName = 'Text';
